import { render, staticRenderFns } from "./MarginStylingComponent.vue?vue&type=template&id=45581c23&"
import script from "./MarginStylingComponent.vue?vue&type=script&lang=js&"
export * from "./MarginStylingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports